import {useGetAllMakesModelsQuery} from '@dms/api/sales';
import {FALLBACK_LANGUAGE, i18n} from '@dms/i18n';

import {PURCHASE_PRICE_RULE_VEHICLE_TYPE} from '../constants/PURCHASE_PRICE_RULE_VEHICLE_TYPE';

/** Passenger car makes and models, shared by the rule list and the rule editor. */
export function usePurchasePriceRuleCatalogue() {
  return useGetAllMakesModelsQuery({
    vehicleType: PURCHASE_PRICE_RULE_VEHICLE_TYPE,
    lang: [i18n.resolvedLanguage ?? FALLBACK_LANGUAGE],
  });
}
